import React, { useMemo, useState } from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade';

interface IProps {
  index: number,
  openIndex: number | null
  title: string,
  description: string
  onClick: () => void
}

export const TextCard = (props: IProps) => {

  const isOpen = useMemo(() => props.index === props.openIndex, [props.index, props.openIndex])

  return (
    <Fade left duration={500} delay={props.index * 100} distance="40px">
      <div className="textCard">
        <div className="textCard--descriptionArea">
          <div className="textCard--descriptionArea--titleArea" onClick={props.onClick}>
            <p className="textCard--descriptionArea--titleArea__title" translate='no'>{props.title}<span translate='no'>性</span></p>
            <i className={`fas ${isOpen ? "fa-minus" : "fa-plus"}`} />
          </div>
          <p className={`textCard--descriptionArea__description ${isOpen && "textCard--descriptionArea__description__open"}`}>
            <p>{props.description}</p>
          </p>
        </div>
      </div>
    </Fade>
  )
}